import { InfoIcon as InfoIconShared } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { TooltipProps } from '@vwfs-bronson/bronson-react/dist/Tooltip';

export type InfoIconProps = {
    text?: string | React.ReactNode;
    title?: string;
    labelId?: string;
    ariaLabel?: string;
    onMouseOver?: () => void;
    tippyProps?: TooltipProps;
};

export const InfoIcon: React.FC<InfoIconProps> = ({ text, title, onMouseOver, labelId, ariaLabel, tippyProps }) => {
    return (
        <InfoIconShared
            aria-label={labelId || ariaLabel}
            icon={'semantic-info'}
            onMouseOver={onMouseOver}
            onClick={e => e.preventDefault()}
            title={title}
            tippyProps={tippyProps}
        >
            {text}
        </InfoIconShared>
    );
};
